import * as React from 'react'
import { Popover } from '@base-ui/react/popover'
import { PopoverPositioner } from './positioner'
import { PopoverPopup } from './popup'
import { PopoverArrow } from './arrow'
import { PopoverBackdrop } from './backdrop'

interface PopoverContentProps {
  className?: string
  children: React.ReactNode
  showArrow?: boolean
  showBackdrop?: boolean
  backdropClassName?: string
  side?: Popover.Positioner.Props['side']
  sideOffset?: Popover.Positioner.Props['sideOffset']
  align?: Popover.Positioner.Props['align']
  alignOffset?: Popover.Positioner.Props['alignOffset']
  anchor?: Popover.Positioner.Props['anchor']
  collisionAvoidance?: Popover.Positioner.Props['collisionAvoidance']
  disableAnchorTracking?: Popover.Positioner.Props['disableAnchorTracking']
  initialFocus?: Popover.Popup.Props['initialFocus']
  finalFocus?: Popover.Popup.Props['finalFocus']
  positionerClassName?: string
  arrowClassName?: string
  style?: React.CSSProperties
}

export function PopoverContent({
  className,
  children,
  showArrow = false,
  showBackdrop = false,
  backdropClassName,
  side = 'bottom',
  sideOffset = 8,
  align,
  alignOffset,
  anchor,
  collisionAvoidance,
  disableAnchorTracking,
  initialFocus,
  finalFocus,
  positionerClassName,
  arrowClassName,
  style,
}: PopoverContentProps) {
  return (
    <Popover.Portal>
      {showBackdrop && <PopoverBackdrop className={backdropClassName} />}
      <PopoverPositioner
        className={positionerClassName}
        side={side}
        sideOffset={sideOffset}
        align={align}
        alignOffset={alignOffset}
        anchor={anchor}
        collisionAvoidance={collisionAvoidance}
        disableAnchorTracking={disableAnchorTracking}
      >
        <PopoverPopup className={className} style={style} initialFocus={initialFocus} finalFocus={finalFocus}>
          {showArrow && <PopoverArrow className={arrowClassName} />}
          {children}
        </PopoverPopup>
      </PopoverPositioner>
    </Popover.Portal>
  )
}
